import {
    Icon,
    TableCell,
    ReplaceButton,
    TableRow,
    Tooltip,
    Stack,
    Typography,
    CellContentPosition,
    IconButton,
    Loader,
    Checkbox,
    Box,
} from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useVatRateText } from "@tm/utils"
import { CustomArticleItemResponse } from "@tm/data/basket"
import { Note } from "@tm/models"
import { useListSettings } from "../useListSettings"

type Props = {
    article: CustomArticleItemResponse
    note?: Note
    currencySymbol?: string
    isSelected?: boolean
    isDeleting?: boolean
    onReplaceConsumable: (consumable: CustomArticleItemResponse) => void
    onEditArticle(article: CustomArticleItemResponse): void
    onToggleArticle(article: CustomArticleItemResponse): void
    onDeleteArticle(article: CustomArticleItemResponse): void
}

export function OwnArticleItem(props: Props) {
    const { article, note, currencySymbol, isDeleting, isSelected, onReplaceConsumable, onDeleteArticle, onEditArticle, onToggleArticle } = props
    const { translateText, formatCurrency } = useLocalization()
    const { vatRateTypeDisplayShortText } = useVatRateText()
    const { showPurchasePrice } = useListSettings()

    const selectedVatRate = article.vatRates?.find((vatRate) => vatRate.isSelected)

    function handleEdit() {
        onEditArticle(article)
    }

    function handleDelete() {
        onDeleteArticle(article)
    }

    function handleToggle() {
        onToggleArticle(article)
    }

    return (
        <TableRow key={article.id} colCount={showPurchasePrice ? 6 : 5}>
            <TableCell>
                <Stack direction="row" justifyContent="space-between" width="100%">
                    <Typography>{article.articleNumber}</Typography>
                    {article.isDefaultForCategory && (
                        <Tooltip title={translateText(12702)}>
                            <Icon name="category-bestseller" />
                        </Tooltip>
                    )}
                </Stack>
            </TableCell>
            <TableCell>{article.description}</TableCell>
            {/* <TableCell />  list name  */}
            {showPurchasePrice && (
                <TableCell alignContent={CellContentPosition.right}>
                    {article.purchasePrice ? formatCurrency(article.purchasePrice, currencySymbol || "") : "-"}
                </TableCell>
            )}
            <TableCell alignContent={CellContentPosition.right}>
                {article.retailPrice ? formatCurrency(article.retailPrice, currencySymbol || "") : "-"}
            </TableCell>
            <TableCell alignContent={CellContentPosition.right} sx={{ pr: 3 }}>
                {!!selectedVatRate &&
                    vatRateTypeDisplayShortText({
                        vatRate: selectedVatRate.vatValue,
                        vatType: selectedVatRate.vatType,
                    })}
            </TableCell>
            <TableCell alignContent={CellContentPosition.right} sx={{ borderLeft: "1px solid #ccc", pl: 2 }}>
                <Stack direction="row" gap={1} alignItems="center">
                    {note ? (
                        <Tooltip title={note.text}>
                            <Icon name="notes-added" color="primary" />
                        </Tooltip>
                    ) : (
                        <Box width="20px" />
                    )}
                    <IconButton title={translateText(122)} onClick={handleEdit}>
                        <Icon name="edit_change" />
                    </IconButton>
                    <IconButton title={translateText(624)} onClick={handleDelete} disabled={isDeleting}>
                        {isDeleting ? <Loader size="small" /> : <Icon name="delete" />}
                    </IconButton>
                    <ReplaceButton disableMargin onClick={() => onReplaceConsumable(article)} />
                    <Checkbox checked={isSelected} onChange={handleToggle} />
                </Stack>
            </TableCell>
        </TableRow>
    )
}
